import ProductSeriesDom from "./productSeries.dom";
import { addListener } from "@grindex-common/helpers/domManipulation";
import { events } from "@grindex-common/helpers/events";
import { refreshSlider } from "@grindex-client/components/Slider/slider";

function init($views) {
	const $module = $views[0];
	const dom = new ProductSeriesDom($module);
	const options = {
		auto: false,
		breaks: [
			{
				screen: 0,
				slides: 1,
				pager: false,
			},
			{
				screen: 460,
				slides: 3,
			},
		],
		pager: false,
	};

	addListener(window, events.TABS_SWITCHED, tabSwitched);

	function tabSwitched() {
		const selectedTab = dom.elements.visibleTabElement();

		if (selectedTab) {
			initCarousel(dom.elements.unInitializedTabSliders());
		}
	}

	function initCarousel($sliders) {
		if (!$sliders || !$sliders.length) {
			return;
		}

		const upTime = $sliders.dataset.pause;

		const defaults = {
			auto: true,
			autoReload: true,
			slideMargin: 20,
			pause: upTime ? upTime * 1000 : 5000,
			autoHover: true,
			useCSS: false,
			onSliderRedraw() {
				refreshSlider(this);
			},
		};

		const settings = Object.assign(defaults, options);

		$sliders.forEach(($slider) => {
			this.dom.addSliderClass($slider).bxSlider(settings);
		});
	}
}

export default {
	view: "productSeries",
	init,
};
